import { render, staticRenderFns } from "./ShopCardDetail.vue?vue&type=template&id=522ac81a&scoped=true"
import script from "./ShopCardDetail.vue?vue&type=script&lang=js"
export * from "./ShopCardDetail.vue?vue&type=script&lang=js"
import style0 from "./ShopCardDetail.vue?vue&type=style&index=0&id=522ac81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ac81a",
  null
  
)

export default component.exports